// Transitions
export const FORM_VALID_TRANSITION_DECEASED_DETAILS =
  "sizotsaFuneralClaim/deceasedDetails/transition/formValid";
export const FORM_INVALID_TRANSITION_DECEASED_DETAILS =
  "sizotsaFuneralClaim/deceasedDetails/transition/formInvalid";
export const PERSONAL_DETAILS_FORM_SET_VALUE =
  "sizotsaFuneralClaim/deceasedDetails/transition/formValue";
export const setPersonalDetailFormValues = () => ({
  type: PERSONAL_DETAILS_FORM_SET_VALUE,
});

export const transitionDeceasedDetails = {
  formValid: () => ({ type: FORM_VALID_TRANSITION_DECEASED_DETAILS }),
  formInvalid: () => ({ type: FORM_INVALID_TRANSITION_DECEASED_DETAILS }),
};

export const INVALID_CONTINUE_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/deceasedDetails/transition/invalidContinue";
export const CONTINUE_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/deceasedDetails/transition/validContinue";
export const BACK_TRANSITION_PERSONAL_DETAIL =
  "sizotsaFuneralClaim/deceasedDetails/transition/back";
export const invalidContinuePersonalDetails = () => ({
  type: INVALID_CONTINUE_TRANSITION_PERSONAL_DETAILS,
});
export const continuePersonalDetails = () => ({
  type: CONTINUE_TRANSITION_PERSONAL_DETAILS,
});
export const backPersonalDetails = () => ({
  type: BACK_TRANSITION_PERSONAL_DETAIL,
});

// Transition - reset state
export const RESET_STATE_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/deceasedDetails/transition/resetState";
export const resetPersonalDetails = () => ({
  type: RESET_STATE_TRANSITION_PERSONAL_DETAILS,
});

// Events
export const PERSONAL_DETAILS_CLEAR_VALUE =
  "sizotsaFuneralClaim/deceasedDetails/clearValue/";
export const DECEASED_DETAILS_SET_VALUE =
  "sizotsaFuneralClaim/deceasedDetails/setValue/";
export const DECEASED_DETAILS_FIELD_SET_VALID =
  "sizotsaFuneralClaim/deceasedDetails/setValid/";

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_PERSONAL_DETAILS =
  "sizotsaFuneralClaim/deceasedDetails/transition/dropOffLead";
export const dropOffLeadPersonalDetails = (dropOffDetails) => ({
  type: DROP_OFF_LEAD_TRANSITION_PERSONAL_DETAILS,
  dropOffDetails,
});


export const setDeceasedDetailsValue =(value)=>({type: DECEASED_DETAILS_SET_VALUE, value})
export const setDeceasedDetailsFieldValid =(error,fieldType)=>({type: DECEASED_DETAILS_FIELD_SET_VALID, error, fieldType})
